import Mutations from "./referrer-mutations";
import Actions from "./referrer-actions";
import Getters from "./referrer-getters";
import DefaultState from "./referrer-default-state";
export default {
  namespaced: true,
  state: DefaultState,
  mutations: Mutations,
  actions: Actions,
  getters: Getters
};